import { useMutation, useQuery, useQueryClient } from "react-query";
import {
	approveOA,
	checkStatusOA,
	consumeOAProductLine,
	deleteOA,
	duplicateOA,
	finishOA,
	getOAConsumptionAvailability,
	getOADocuments,
	getOAList,
	getOALookups,
	getOAPrices,
	saveOAPrices,
	rejectOA,
	returnStateOA,
} from "@/api/Planning/oa/oa-api";

export const oaKey = "oa-list";

export const oaConsumptionAvailabilityKey = (oaId) => ["oa-consumption-availability", oaId];

export function useOAList(filters, options = {}) {
	return useQuery([oaKey, filters], () => getOAList(filters), {
		keepPreviousData: true,
		...options,
	});
}

export function useOADuplicate() {
	return useMutation(duplicateOA);
}

export function useOADocuments() {
	return useMutation(getOADocuments);
}

export function useOAApprove() {
	return useMutation(approveOA);
}

export function useOAReject() {
	return useMutation(rejectOA);
}

export function useOAFinish() {
	return useMutation(finishOA);
}

export function useOAReturnState() {
	return useMutation(returnStateOA);
}

export function useOACheckStatus() {
	return useMutation(checkStatusOA);
}

export function useOADelete() {
	return useMutation(deleteOA);
}

export function useOAPrices(oaId, options = {}) {
	return useQuery(["oa-prices", oaId], () => getOAPrices(oaId), {
		enabled: Boolean(oaId),
		staleTime: 0,
		refetchOnMount: "always",
		...options,
	});
}

export function useSaveOAPrices() {
	return useMutation(saveOAPrices);
}

export function useOAConsumptionAvailability(oaId, options = {}) {
	return useQuery(oaConsumptionAvailabilityKey(oaId), () => getOAConsumptionAvailability(oaId), {
		enabled: Boolean(oaId),
		...options,
	});
}

export function useConsumeOAProductLine() {
	const queryClient = useQueryClient();

	return useMutation(consumeOAProductLine, {
		onSuccess: (response, variables) => {
			queryClient.setQueryData(oaConsumptionAvailabilityKey(variables.oa_id), response);
		},
	});
}

export function useOALookups(options = {}) {
	return useQuery(["oa-lookups"], () => getOALookups(), {
		staleTime: 5 * 60 * 1000,
		...options,
	});
}
